import { observable } from 'mobx';
import { useEffect } from 'react';
import toWebpImage from '@src/utils/to-webp-image';

/**
 * 锚点导航组件状态管理
 */
class AnchorNavStore {
  /**
   * 构造函数
   * @param {object} options - 初始化选项
   */
  constructor(options = {}) {
    Object.assign(this, options);
  }

  @observable
  anchorList = [
    {
      text: '首页',
      subTextImg: toWebpImage(require('./images/text-home.png'))
    },
    {
      text: '新机兵',
      subTextImg: toWebpImage(require('./images/text-new-mecha.png'))
    },
    {
      text: '全新路网合约',
      subTextImg: toWebpImage(require('./images/text-seasonPass.png'))
    },
    {
      text: '赛季亮点',
      subTextImg: toWebpImage(require('./images/text-feature.png'))
    },
    {
      text: '游戏特色',
      subTextImg: toWebpImage(require('./images/text-highlights.png'))
    }
  ];

  @observable activeIndex = 0;

  setActiveIndex(index) {
    this.onChange(index);
  }

  /**
   * React Hook 生命周期
   */
  use() {
    useEffect(() => {
      return () => {};
    }, []);
  }
}

export default AnchorNavStore;
